import { z } from 'zod'

import { CAA } from './CAA'
import { CAACountByAvailability } from './CAACountByAvailability'

export const CAAResponse = z.object({
  clientUsage: z.number(),
  modeling: z.number(),
  availabilities: z.array(CAACountByAvailability),
  caa: z.array(CAA)
})
export type CAAResponse = z.infer<typeof CAAResponse>
